import React from 'react';
import logo from './logo.svg';
import './App.css';
import { Route, withRouter, RouteComponentProps, BrowserRouter, Switch } from 'react-router-dom';
import axios from './helpers/axios';

import i18n from './i18n/config';

import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Buyers from './components/diversion/Buyers';
import Typography from '@mui/material/Typography';

import Nav from './components/Nav';
import Login from './components/user/Login';
import Home from './components/Home';

import CustomersList from './components/neighbourhood/CustomersList';
import CustomerDetails from './components/neighbourhood/CustomerDetails';
import CustomerLeads from './components/neighbourhood/CustomerLeads';
import CustomerLeadDetails from './components/neighbourhood/CustomerLeadDetails';
import TicketsList from './components/neighbourhood/TicketsList';
import TicketDetails from './components/neighbourhood/TicketDetails';

import Payments from './components/payments/Payments';
import PaymentsForReview from './components/payments/PaymentsForReview';
import TransactionsPendingApproval from './components/payments/TransactionsPendingApproval';
import Diversion from './components/diversion/Diversion';
import IncomingWaste from './components/diversion/IncomingWaste';
import DivertedWaste from './components/diversion/DivertedWaste';
import OutgoingWaste from './components/diversion/OutgoingWaste';
import IncomingWasteCharts from './components/diversion/IncomingWasteCharts';
import DivertedWasteCharts from './components/diversion/DivertedWasteCharts';
import OutgoingWasteCharts from './components/diversion/OutgoingWasteCharts';
import Agents from './components/operations/Agents';
import AgentDetails from './components/operations/AgentDetails';
import Maintenance from './components/operations/Maintenance';
import Expenses from './components/operations/Expenses';
import VehicleCharts from './components/operations/VehicleCharts';
import Offers from './components/alerts/Offers';
import Notifications from './components/alerts/Notifications';
import Surveys from './components/alerts/Surveys';
import Profile from './components/Profile';
import NeighbourhoodList from './components/neighbourhood/NeighbourhoodList';
import NeighbourhoodDetails from './components/neighbourhood/NeighbourhoodDetails';
import Settings from './components/settings/Settings';
import GroupPickups from './components/operations/GroupPickups';
import PickupDetails from './components/operations/PickupDetails';
import BagInventory from './components/operations/BagInventory';
import PausePickup from './components/neighbourhood/PausePickup';
import InactiveRegistrations from './components/neighbourhood/InactiveRegistrations';
import AcceptanceStat from './components/settings/AcceptanceStat';
import SMSTemplate from './components/settings/SMSTemplate';
import CommunityReport from './components/reports/CommunityReport';
import BagDetails from './components/operations/BagDetails';
import NeighbourhoodUsers from './components/neighbourhood/NeighbourhoodUsers';
import BatchPickups from './components/operations/BatchPickups';
import BagDistribution from './components/operations/BagDistribution';

import Distribution from './components/operations/Distribution';
import CityReport from './components/reports/CityReport';
import BadBagReport from './components/reports/BadBagReport';
import OddBagReport from './components/reports/OddBagReport';
import SummaryReport from './components/reports/SummaryReport';
import NeighbourhoodPickups from './components/neighbourhood/NeighbourhoodPickups';
import GroupBagDistribution from './components/operations/GroupBagDistribution';
import DeleteSets from './components/operations/DeleteSets';
import CommunityPickups from './components/operations/CommunityPickups';
import PickupPoints from './components/operations/PickupPoints';
import BalanceSheet from './components/reports/BalancedSheet';
import Inventory from './components/diversion/inventory';
import BagWeightsForReview from './components/payments/BagWeightsForReview';

const drawerWidth = 0;


export interface IState {
  user: {
    id: number;
    name: string;
    email: string;
    role: string;
    is_active: boolean;
    selectedHierarchies: any[];
    selectedHierarchyIds: any[];
  };
}

export interface IState {
  drawerWidth: any;
}

class App extends React.Component<RouteComponentProps<any>, IState> {
  constructor(props: RouteComponentProps) {
    super(props);
    this.state = {
      user: {
        id: 0,
        name: '',
        email: '',
        role: '',
        is_active: false,
        selectedHierarchies: [],
        selectedHierarchyIds: []
      },
      drawerWidth: 240,
    }
  }
  public componentDidMount(): void {
    if (localStorage.getItem('token')) {
      this.fetchProfileDetails();
    }
  }

  public fetchProfileDetails() {
    axios.get(`profile`).then(response => {
      let user = response.data.data.user;
      if (user) {
        if (localStorage.getItem('selectedHierarchies')) {
          user.selectedHierarchies = localStorage.getItem('selectedHierarchies');
          user.selectedHierarchies = JSON.parse(user.selectedHierarchies);
        }
        if (localStorage.getItem('selectedHierarchyIds')) {
          user.selectedHierarchyIds = localStorage.getItem('selectedHierarchyIds');
          user.selectedHierarchyIds = JSON.parse(user.selectedHierarchyIds);
        }
        this.setState({ user: user });
      }
    })
  }

  public render() {
    const user = this.state.user;

    const handleHierarchiesSelection = (selectedHierarchies: any[] = []) => {
      let selectedHierarchyIds: any[] = [];
      selectedHierarchies.map((selectedHierarchyId: any) => {
        selectedHierarchyIds.push(selectedHierarchyId.id);
      })
      this.setState({ user: { ...this.state.user, selectedHierarchies, selectedHierarchyIds } });
      localStorage.setItem('selectedHierarchies', JSON.stringify(selectedHierarchies));
      localStorage.setItem('selectedHierarchyIds', JSON.stringify(selectedHierarchyIds));
    }

    const collapseDrawer = (drawerWidth: any) => {
      this.setState({drawerWidth: drawerWidth});
      console.log("drawerWidth", drawerWidth)
    }

    const DefaultRoute = () => {
      if (user.role === 'warehouse_manager') {
        return <Diversion user={user} />;
      } else if (user.role === 'bad_bag_manager') {
        return <BadBagReport user={user} />;
      } else {
        return <Home user={user} />;
      }
    };

    return (
      <div className={(localStorage.getItem('token')) ? "App bg-gray" : "App bg-dark"}>
        <Box sx={{ display: 'flex' }}>
          {
            localStorage.getItem('token') &&
            <Nav user={user} handleHierarchiesSelection={handleHierarchiesSelection} collapseDrawer={collapseDrawer} />
          }
          <Box
            component="main"
            sx={{ flexGrow: 1, p: 3, width: { sm: `calc(100% - ${this.state.drawerWidth}px)` } }}
          >
            <Toolbar sx={{ minHeight: { xs: '80px !important', md: '45px !important' } }} />
            <Switch>
              <Route path={'/'} exact component={DefaultRoute} />
              <Route path={'/neighbourhood/customers'} exact component={() => <CustomersList user={user} />} />
              <Route path={'/neighbourhood/customers/:id'} exact component={() => <CustomerDetails user={user} />} />
              <Route path={'/neighbourhood/customer-leads'} exact component={() => <CustomerLeads user={user} />} />
              <Route path={'/neighbourhood/customer-leads/:id'} exact component={() => <CustomerLeadDetails user={user} />} />
              <Route path={'/neighbourhood/tickets'} exact component={() => <TicketsList user={user} />} />
              <Route path={'/neighbourhood/tickets/:id'} exact component={() => <TicketDetails user={user} />} />
              {/* <Route path={'/payments'} exact component={() => <Payments user={user} />} /> */}
              <Route path={'/payments'} exact component={() => <PaymentsForReview user={user} />} />
              <Route path={'/payments/payments-for-review'} exact component={() => <PaymentsForReview user={user} />} />
              <Route path={'/payments/bag-weights-for-review'} exact component={() => <BagWeightsForReview user={user} />} />
              <Route path={'/payments/transactions-pending-approval'} exact component={() => <TransactionsPendingApproval user={user} />} />
              <Route path={'/diversion'} exact component={() => <Diversion user={user} />} />
              <Route path={'/incoming-waste'} exact component={() => <IncomingWaste user={user} />} />
              <Route path={'/diverted-waste'} exact component={() => <DivertedWaste user={user} />} />
              <Route path={'/outgoing-waste'} exact component={() => <OutgoingWaste user={user} />} />
              <Route path={'/buyers'} exact component={() => <Buyers user={user} />} />
              <Route path={'/inventory'} exact component={() => <Inventory user={user}/>}/>
              <Route path={'/incoming-waste-charts'} exact component={() => <IncomingWasteCharts user={user} />} />
              <Route path={'/diverted-waste-charts'} exact component={() => <DivertedWasteCharts user={user} />} />
              <Route path={'/outgoing-waste-charts'} exact component={() => <OutgoingWasteCharts user={user} />} />

              <Route path={'/alerts'} exact component={() => <Offers user={user} />} />
              <Route path={'/notifications'} exact component={() => <Notifications user={user} />} />
              <Route path={'/surveys'} exact component={() => <Surveys user={user} />} />
              <Route path={'/profile'} exact component={() => <Profile user={user} />} />

              <Route path={'/neighbourhood/community-list'} exact component={() => <NeighbourhoodList user={user} />} />
              <Route path={'/neighbourhood/community-list/:id'} exact component={() => <NeighbourhoodDetails user={user} />} />
              <Route path={'/neighbourhood/community-list/:id/users'} exact component={() => <NeighbourhoodUsers user={user} />} />
              <Route path={'/neighbourhood/community-list/:id/pickups'} exact component={() => <NeighbourhoodPickups user={user}/>} />




              <Route path={'/neighbourhood/pause-pickups'} exact component={() => <PausePickup user={user} />} />
              <Route path={'/neighbourhood/inactive-registrations'} exact component={() => <InactiveRegistrations user={user} />} />
              
              <Route path={'/settings/constants'} exact component={() => <Settings user={user} />} />
              <Route path={'/settings/acceptance-stat'} exact component={() => <AcceptanceStat user={user} />} />
              <Route path={'/settings/sms-template'} exact component={() => <SMSTemplate user={user} />} />


              <Route path={'/operations/batch-pickups'} exact component={() => <BatchPickups user={user} />} />
              <Route path={'/operations/batch-pickups/group-pickups/:id'} exact component={() => <GroupPickups user={user} />} />
              <Route path={'/operations/batch-pickups/group-pickups/pickup-details/:id'} exact component={() => <PickupDetails user={user} />} />
              <Route path={'/operations/bag-distribution'} exact component={() => <BagDistribution user={user} />} />
              <Route path={'/operations/bag-distribution/group-bag-distribution/:id'} exact component={() => <GroupBagDistribution user={user} />} />
              
              <Route path={'/operations/community-pickups'} exact component={() => <CommunityPickups user={user} />} />
              <Route path={'/operations/pickup-points'} exact component={() => <PickupPoints user={user} />} />

              <Route path={'/operations/bag-distribution/batches/:id'} exact component={() => <Distribution user={user} />} />
              <Route path={'/operations/bag-distribution/batches/bag-details/:id'} exact component={() => <BagDetails user={user} />} />
              <Route path={'/operations/bag-inventory'} exact component={() => <BagInventory user={user} />} />
              <Route path={'/operations/agents'} exact component={() => <Agents user={user} />} />
              <Route path={'/operations/delete-sets'} exact component={() => <DeleteSets user={user} />} />

              <Route path={'/operations/agents/:id'} exact component={() => <AgentDetails user={user} />} />
              <Route path={'/operations/maintenance'} exact component={() => <Maintenance user={user} />} />
              <Route path={'/operations/expenses'} exact component={() => <Expenses user={user} />} />
              <Route path={'/operations/vehicle-maintenance-charts'} exact component={() => <VehicleCharts user={user} />} />

              {/* <Route path={'/reports'} exact component={() => <CommunityReport user={user} />} /> */}
              <Route path={'/reports/community-report'} exact component={() => <CommunityReport user={user} />} />
              <Route path={'/reports/city-report'} exact component={() => <CityReport user={user} />} />
              <Route path={'/reports/bad-bag-report'} exact component={() => <BadBagReport user={user} />} />
              <Route path={'/reports/odd-bag-report'} exact component={() => <OddBagReport user={user} />} />
              <Route path={'/reports/balance-sheet'} exact component={() => <BalanceSheet user={user} />}/>
              <Route path={'/reports/summary-report'} exact component={() => <SummaryReport user={user} />} />


              <Route path={'/login'} exact component={Login} />
            </Switch>
          </Box>
        </Box>
      </div>
    );
  }
}
export default withRouter(App);
